import { useTranslation } from 'react-i18next';
import { useLiveQuery } from 'dexie-react-hooks';
import { db } from '../../db/local.js';
import type { LocalRecipe } from '../../db/local.js';
import { macrosOfRecipe } from '../../db/nutrition.js';

export function RecipeMacroLine({
  recipe,
  compact = false,
}: {
  recipe: LocalRecipe;
  /** In der Kachel: ohne „aus Zutaten gerechnet" — dafür ist dort kein Platz. */
  compact?: boolean;
}): React.JSX.Element {
  const { t } = useTranslation();
  const macros = useLiveQuery(
    () => macrosOfRecipe(recipe, db),
    [recipe.id, recipe.updatedAt],
    null,
  );

  if (!macros) {
    // Ein Gericht ohne Werte ist im Protokoll wertlos — das steht hier, statt
    // eine Null zu zeigen.
    return <span className="text-warn">{t('nutrition.recipe.noMacros')}</span>;
  }

  return (
    <span>
      {Math.round(macros.kcal)} kcal · {Math.round(macros.protein)} g {t('nutrition.macro.protein')}
      {compact ? null : (
        <span className="text-ink-muted">
          {' '}
          ·{' '}
          {recipe.macroSource === 'ingredients'
            ? t('nutrition.recipe.fromIngredients')
            : t('nutrition.recipe.entered')}
        </span>
      )}
    </span>
  );
}
